import ShipmentFA from './fa/fa.json'

const ShipmentMessages = {
  fa: { ...ShipmentFA },
}

export default ShipmentMessages
